<template>
  <div>
    <div class="container-fluid mb-20">
      <div v-for="(section, i) in sectionSortedByOrder" :key="i">
        <vs-divider>
          <span class="uppercase">{{ section.text }}</span>
        </vs-divider>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          <menu-grid-item v-for="(item, index) in sortedByOrder(section.children)" v-if="canView(item, 'submenu')"
            :key="index" :route="item.route.path" :version="item.version" :title="item.text"></menu-grid-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuGridItem from "@components/menu-grid/menu-grid-item";
import _ from "lodash";

export default {
  name: "menu-grid",
  components: { MenuGridItem },
  computed: {
    sectionSortedByOrder() {
      return _.orderBy(this.sections, ['order'], ['asc']);
    }
  },
  props: {
    sections: {
      type: Array,
      required: true
    }
  },
  methods: {
    sortedByOrder(items) {
      return _.orderBy(items, ['order'], ['asc']);
    }
  }
}
</script>
